import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BaseApiClient } from './base-api-client.service';
import { LogService } from './log.service';
import { Environment } from '@env/environment';
import { UserMetadata } from '../models/user-metadata-dto';

export interface IIdentityManagementService {
	url: string;
	geImpersonationStart(userMetadata: UserMetadata): Observable<boolean>;
	geImpersonationEnd(): Observable<boolean>;
}

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
	providedIn: 'root',
})
export class IdentityManagementService extends BaseApiClient implements IIdentityManagementService {
	public url: string; // URL to web api

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		environment: Environment
	) {
		super();
		this.url = environment.services['identityManagement'];
	}

	geImpersonationStart(userMetadata: UserMetadata): Observable<boolean> {
		const url = `${this.url}v1/User/impersonate/start/${userMetadata.ImpersonateeUserId}`;
		return this.http.get<any>(url).pipe(
			tap((): void => {
				this.log.logInformation(`Got Impersonation Start`);
			}),
			catchError(this.createErrorResponseHandler(this.log))
		);
	}

	geImpersonationEnd(): Observable<boolean> {
		const url = `${this.url}v1/User/impersonate/end`;
		return this.http.get<any>(url).pipe(
			tap((): void => {
				this.log.logInformation(`Got Impersonation End`);
			}),
			catchError(this.createErrorResponseHandler(this.log))
		);
	}
}
